var _path, _path2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346631 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346631 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 0.804671C6.5769 0.804671 5.18576 1.22667 4.00249 2.0173C2.81922 2.80794 1.89698 3.93169 1.35238 5.24647C0.807785 6.56124 0.665293 8.00798 0.942927 9.40374C1.22056 10.7995 1.90585 12.0816 2.91213 13.0879C3.91842 14.0942 5.2005 14.7794 6.59626 15.0571C7.99202 15.3347 9.43876 15.1922 10.7535 14.6476C12.0683 14.103 13.1921 13.1808 13.9827 11.9975C14.7733 10.8142 15.1953 9.4231 15.1953 8C15.1936 6.0922 14.435 4.26303 13.086 2.91402C11.737 1.565 9.9078 0.806375 8 0.804671Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58689 6.5976C6.14239 6.5976 6.59272 6.14728 6.59272 5.59177C6.59272 5.03626 6.14239 4.58594 5.58689 4.58594C5.03138 4.58594 4.58105 5.03626 4.58105 5.59177C4.58105 6.14728 5.03138 6.5976 5.58689 6.5976Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.415 6.5976C10.9705 6.5976 11.4208 6.14728 11.4208 5.59177C11.4208 5.03626 10.9705 4.58594 10.415 4.58594C9.85951 4.58594 9.40918 5.03626 9.40918 5.59177C9.40918 6.14728 9.85951 6.5976 10.415 6.5976Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10.5,
    x2: 13,
    y2: 10.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.ee1fbae1c34ff896c3eb4ee9a6272fac.svg";
export { ForwardRef as ReactComponent };